import React, { useEffect, useMemo, useState } from 'react';
import {
  LoadingStatus,
  toastMessage,
  ToastThemes,
} from '../../../../constants/common';
import { TaskAltOutlined } from '@mui/icons-material';
import BtnDropDown from '../../../../atoms/Buttons/BtnDropDown';
import ModalDialog from '../../../../atoms/Modal/ModalDialog';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';
import { OnboardingServices } from '../../../../services/onboarding';
import { showToast } from '../../../../utils/common.util';
import {
  stringSubstitute,
  ToastMessages,
} from '../../Organization/constants/onboarding.constants';

const AllUserMultiselectModalMap = (props) => {
  const {
    checkedItems,
    searchQuery,
    currentUserRoleId,
    selectedDate,
    setList,
  } = props;
  const [showModal, setshowModal] = useState(false);
  const [context, setContext] = useState('');
  const [postActionLoading, setPostActionLoading] = useState(-1);

  const handleFundClick = () => {
    setContext('join');
    setshowModal(true);
  };

  const handleSaveClick = async () => {
    setPostActionLoading(LoadingStatus.Loading);
    await new OnboardingServices()
      .postImportATS({
        candidateIds: checkedItems.map((item) => Number(item)),
      })
      .then(async () => {
        await new OnboardingServices()
          .getATSCandidate(
            currentUserRoleId,
            searchQuery
          )
          .then((res) => {
            setList(res);
          });
        setPostActionLoading(LoadingStatus.Success);
        showToast(
          ToastMessages.success.replace(stringSubstitute, toastMessage.update),
          ToastThemes.success
        );
      })
      .catch((err) => {
        setPostActionLoading(LoadingStatus.Failure);
        showToast(err?.response?.data?.message, ToastThemes.error);
      });
  };

  const modalMap = {
    join: {
      title: 'Onboard User',
      listComponent: (
        <>
          Are you sure you want to Onboard all selected Users
          {/* <br />
          from the{' '}
          <strong>
            {checkedItems[0]?.isNewTaxRegime ? 'New' : 'Old'} Tax Regime
          </strong>{' '}
          to the{' '}
          <strong>
            {checkedItems[0]?.isNewTaxRegime ? 'Old' : 'New'} Tax Regime
          </strong>
          ? */}
        </>
      ),
      primaryAction: 'Save',
      onClickConfirm: () => handleSaveClick(),
      severity: 'success',
      maxWidth: 'md',
      fullWidth: true,
    },
  };

  const btnOptions = [
    {
      title: 'Onboard',
      icon: <TaskAltOutlined sx={{ width: 20, height: 20 }} />,
      handleClick: handleFundClick,
      disabled: false,
    },
  ];

  return (
    <>
      <CircularLoader show={postActionLoading === LoadingStatus.Loading} />
      <BtnDropDown
        BtnOptions={btnOptions}
        selectedOption={0}
        disabled={!checkedItems.length}
      />
      <ModalDialog
        severity={modalMap[context]?.severity}
        title={modalMap[context]?.title}
        listComponent={modalMap[context]?.listComponent}
        description={modalMap[context]?.description}
        primaryAction={modalMap[context]?.primaryAction}
        secondaryAction="Cancel"
        showModal={showModal}
        onClickClose={() => setshowModal(false)}
        onClickConfirm={modalMap[context]?.onClickConfirm}
        maxWidth={modalMap[context]?.maxWidth}
        fullWidth={modalMap[context]?.fullWidth}
      />
    </>
  );
};

export default AllUserMultiselectModalMap;
